import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private _loading = new BehaviorSubject<boolean>(false);
  public readonly loading$ = this._loading.asObservable();

  constructor() {}

  private loadingKeys: string[] = []

  addLoadingKey(key: string) {
    if (this.loadingKeys.length == 0) {
      this.show()
    }
    this.loadingKeys.push(key)
  }

  removeLoadingKey(key: string) {
    this.loadingKeys.forEach((value, index)=>{
      if(value==key) this.loadingKeys.splice(index,1);
    });
    if (this.loadingKeys.length == 0) {
      this.hide()
    }
  }

  private show() {
    this._loading.next(true);
  }

  private hide() {
    this._loading.next(false);
  }
}
